export default __webpack_public_path__ + "static/qaHeroSecurity-c80a220cde61e423944afa5fb885aca1.png";